import React from 'react'
import Button from '@Components/Buttons/Button'

interface CatalogTransferButtonContainerProps {
    step: 'welcome' | 'type'
    setStep: (step: 'welcome' | 'type') => void
}

const CatalogTransferButtonContainer = ({ step, setStep }: CatalogTransferButtonContainerProps) => (
    <div className="ct-button-container">
        {step === 'type' && (
            <Button className="back-button" mainColor type="secondary" onClick={() => setStep('welcome')}>
                Back
            </Button>
        )}
        {step === 'welcome' && (
            <Button mainColor type="primary" onClick={() => setStep('type')}>
                Next
            </Button>
        )}
    </div>
)

export default CatalogTransferButtonContainer
